/**
 * FormField — label + control + hint/error, shared by TextField and Select
 * so a11y wiring (aria-describedby, aria-invalid) lives in one place rather
 * than being duplicated per control.
 */
export function FormField({ id, label, required, hint, error, control }) {
  const wrap = document.createElement("div");
  wrap.className = "form-field";

  const labelEl = document.createElement("label");
  labelEl.className = "form-label";
  labelEl.htmlFor = id;
  labelEl.textContent = required ? `${label} *` : label;
  wrap.append(labelEl);

  const describedBy = [];
  if (hint) describedBy.push(`${id}-hint`);
  if (error) describedBy.push(`${id}-error`);
  if (describedBy.length) control.setAttribute("aria-describedby", describedBy.join(" "));
  control.setAttribute("aria-invalid", error ? "true" : "false");
  if (required) control.required = true;

  wrap.append(control);

  if (hint && !error) {
    const hintEl = document.createElement("p");
    hintEl.id = `${id}-hint`;
    hintEl.className = "form-hint";
    hintEl.textContent = hint;
    wrap.append(hintEl);
  }

  if (error) {
    const errorEl = document.createElement("p");
    errorEl.id = `${id}-error`;
    errorEl.className = "form-error";
    errorEl.textContent = error;
    wrap.append(errorEl);
  }

  return wrap;
}
